var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      staticClass: "modal-content",
      attrs: {
        title: _vm.title,
        width: 600,
        visible: _vm.visible,
        "ok-text": "保存",
      },
      on: { ok: _vm.handleOk, cancel: _vm.hideModal },
    },
    [
      _c(
        "a-tabs",
        { attrs: { activeKey: _vm.activeKey }, on: { change: _vm.changeTab } },
        _vm._l(_vm.tabList, function (item) {
          return _c(
            "a-tab-pane",
            { key: item.key, attrs: { tab: item.tab } },
            [
              _c(
                "div",
                { staticStyle: { "margin-bottom": "10px", color: "#fa9600" } },
                [
                  _vm._v(
                    "\n        *可根据系统提供的模版进行填写后在上传，也可直接进行第二步\n      "
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "flex-align-center",
                  staticStyle: { "margin-bottom": "10px" },
                },
                [
                  _c("span", { staticClass: "title-2" }, [
                    _vm._v("第一步：下载模版"),
                  ]),
                  _c(
                    "a",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { href: item.fileUrl },
                    },
                    [_vm._v("下载" + _vm._s(item.fileName))]
                  ),
                ]
              ),
              _c(
                "a-upload-dragger",
                {
                  attrs: {
                    disabled: false,
                    name: "file",
                    "file-list": _vm.fileList,
                    action: _vm.importExcelUrl,
                    headers: _vm.tokenHeader,
                  },
                  on: { change: _vm.handleChange },
                },
                [
                  _c(
                    "p",
                    { staticClass: "ant-upload-drag-icon" },
                    [_c("a-icon", { attrs: { type: "inbox" } })],
                    1
                  ),
                  _c("p", { staticClass: "ant-upload-text" }, [
                    _vm._v("添加文件"),
                  ]),
                ]
              ),
              _c(
                "div",
                { staticClass: "title-2", staticStyle: { margin: "10px 0" } },
                [_vm._v("第二步：干预记录")]
              ),
              _c(
                "a-form-model",
                {
                  ref: "ruleForm",
                  refInFor: true,
                  attrs: {
                    labelCol: { span: 4 },
                    wrapperCol: { span: 20 },
                    model: _vm.form,
                    rules: _vm.rules,
                  },
                },
                [
                  _vm.activeKey === "5"
                    ? _c(
                        "a-form-model-item",
                        { attrs: { label: "辅导方法" } },
                        [
                          _c("j-dict-select-tag", {
                            attrs: {
                              placeholder: "请选择辅导方法",
                              dictCode: "tutoring_method",
                            },
                            model: {
                              value: _vm.form.tutoringMethod,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "tutoringMethod", $$v)
                              },
                              expression: "form.tutoringMethod",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "问题原因" } },
                    [
                      _c("j-dict-select-tag", {
                        attrs: {
                          placeholder: "请选择问题原因",
                          dictCode: "emotional_type",
                        },
                        model: {
                          value: _vm.form.tagId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "tagId", $$v)
                          },
                          expression: "form.tagId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "干预措施" } },
                    [
                      _c("j-dict-select-tag", {
                        attrs: {
                          placeholder: "请选择干预措施",
                          dictCode: "intervention",
                        },
                        model: {
                          value: _vm.form.interventionId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "interventionId", $$v)
                          },
                          expression: "form.interventionId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "效果反馈" } },
                    [
                      _c("j-dict-select-tag", {
                        attrs: {
                          placeholder: "请选择效果反馈",
                          dictCode: "effect_feedback",
                        },
                        model: {
                          value: _vm.form.effectFeedback,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "effectFeedback", $$v)
                          },
                          expression: "form.effectFeedback",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "关爱等级" } },
                    [
                      _c("j-dict-select-tag", {
                        attrs: {
                          placeholder: "请选择关爱等级",
                          dictCode: "care_list",
                        },
                        model: {
                          value: _vm.form.careList,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "careList", $$v)
                          },
                          expression: "form.careList",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "具体情况说明" } },
                    [
                      _c("a-textarea", {
                        attrs: {
                          "auto-size": { minRows: 5, maxRows: 8 },
                          placeholder: "请输入具体情况说明",
                        },
                        model: {
                          value: _vm.form.comment,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "comment", $$v)
                          },
                          expression: "form.comment",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }